import { NgModule, Type } from '@angular/core';
import { InputTextComponent } from './input-text.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextAreaInputComponent } from './text-area.component';
import { CheckboxInputComponent } from './checkbox.component';
import { CmbEntityComponent } from './cmb-entity.component';

const components: Type<any>[] = [
  InputTextComponent,
  TextAreaInputComponent,
  CheckboxInputComponent,
  CmbEntityComponent,
];

@NgModule({
  imports: [ReactiveFormsModule, FormsModule, CommonModule, ...components],
  exports: [...components],
})
export class CommonsInputsModule {}
